import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from './../DocumentStatusCards.module.scss'
import overview from 'assets/icons/overview.png'
import edit from 'assets/icons/edit_document_statistic.png'
import completed from 'assets/icons/task_statistic.png'
import inventory from 'assets/icons/inventory_statistic.png'
const Card = ({ title, data }) => {
  const { t } = useTranslation('common')
  return (
    <div className={styles.card_wrapper}>
      <h3>{title}</h3>
      <div className={styles.card_flex}>
        <div className={styles.flex_column}>
          <span>{t('statistic.standby')}</span>
          <div className={styles.flex}>
            <img src={overview} alt="" />
            <h2>{data?.standby}</h2>
          </div>
        </div>
        <div className={styles.flex_column}>
          <span>{t('statistic.in_progress')}</span>
          <div className={styles.flex}>
            <img src={edit} alt="" />
            <h2>{data?.progress}</h2>
          </div>
        </div>
        <div className={styles.flex_column}>
          <span>{t('statistic.completed')}</span>
          <div className={styles.flex}>
            <img src={completed} alt="" />
            <h2>{data?.complete}</h2>
          </div>
        </div>
        <div className={styles.flex_column}>
          <span>{t('statistic.total_label')}</span>
          <div className={styles.flex}>
            <img src={inventory} alt="" />
            <h2>{data?.total}</h2>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Card
